import React from 'react';
import './middlenote.css'; // Import the CSS file

const SuccessfulListening = () => {
  return (
    <div className="container">
      <div className="box">
        <p className="subheading"> But those who hope in the LORD shall renew their strength.</p>
<p className='signature'>Isaiah 40:31</p>
      </div>
    </div>
  );
};

export default SuccessfulListening;
